<kendo-dialog *ngIf="newReferralDialogOpened" (close)="closeModal()" [width]="350">
    <kendo-dialog-titlebar>
        <h3>{{ 'NEW-REFERRAL' | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="newReferralForm" class="k-form">
        <div class="mt-3">
            <input type="radio" value="SEARCH-FOR-SERVICES" name="newReferralType" formControlName="newReferralType"
                id="radioSearch" kendoRadioButton />
            <label class="k-radio-label" for="radioSearch">{{'SEARCH-FOR-SERVICES' | translate}}</label>
            <br />
            <input type="radio" value="ASSESSMENTS" name="newReferralType" formControlName="newReferralType"
                id="radioAssessment" kendoRadioButton />
            <label class="k-radio-label" for="radioAssessment">{{'WORK-WITH-ASSESSMENTS' | translate}}</label>
        </div>
    </form>
    <kendo-dialog-actions>
        <button class="k-button" (click)="closeModal()">{{ 'CANCEL' | translate }}</button>
        <button class="k-button k-primary" (click)="onSelectedNewReferralType()"
            [disabled]="!newReferralForm.valid || !newReferralForm.dirty">
            {{'SELECT' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>